import React from "react";
import ReactDOM from "react-dom/client";
import TagManager from "react-gtm-module";

import * as Sentry from "@sentry/react";

import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from "react-router-dom";

import { App } from "./App";

import "./style.css";

if (!__DEV__) {
  const tagManagerArgs = {
    gtmId: "GTM-NV5RZ4TV",
  };
  TagManager.initialize(tagManagerArgs);
}

if (!__DEV__) {
  Sentry.init({
    dsn: "https://b66ca19a407e010a81c1d4b0eef9a631@o252081.ingest.us.sentry.io/4507210101686272",
    integrations: [
      // see navigation.tsx for where <Routes> prop is wrapped
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    // set at build time, e.g. `SENTRY_RELEASE=$(git rev-parse HEAD) SENTRY_ENV=production yarn build-prod
    environment: __SENTRY_ENVIRONMENT__,
    release: __SENTRY_RELEASE__,
    // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring.
    tracesSampleRate: 1.0,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
